import React, { useState } from "react";
import Button from "../../../../utils/components/Button";
import Table from "../../../../utils/components/Table";
import LineUpModal from "./LineUpModal";
import PlayersModal from "./PlayersModal";
import LineUpConfigModal from "./LineUpConfigModal";
import LineUpCaptainModal from "./LineUpCaptainModal";
import LineUpBonusModal from "./LineUpBonusModal";
import UploadFileButton from "../../../../utils/components/UploadFileButton";
import roles from "../../../../config/roles";
import FinancialModal from "../../../organizers/financial/components/FinancialModal";

const LineUpList = ({
  lineups,
  loadingFetchLineups,
  teams,
  tournamentId,
  organizerId,
  createNewLineup,
  deleteLineup,
  showPlayersModal,
  hidePlayersModal,
  player,
  players,
  clearSinglePlayer,
  setPlayerKeyValue,
  addPlayerToLineup,
  setSinglePlayer,
  loadingDeleteLineup,
  loadingAddPlayerToLineup,
  openLineupPlayersModal,
  updatePlayer,
  clearAllPlayers,
  loadingFetchPlayers,
  loadingUpdatePlayer,
  loadingDeletePlayer,
  deletePlayerHandler,
  showDeleteButton,
  deletePlayerImageHandler,
  addLineupCaptain,
  updateTournament,
  uploadMasiveLinupPlayersHandler,
  refreshLineups,
  downloadLineupsAndPlayersHandler,
  addLineupBonus,
  floatingAlert,
  // Reva Props
  priceLists,
  selectedLineupInvoices,
  selectedLineupFinancials,
  selectedLineupSiloBalances,
  loadLineupFinancials,
  loadPriceList,
  applyPriceItem,
  registerInvoicesPayment,
  registerAddBalance,
  loadingReva,
  revaConnectionError,
  // New props for Origin Tracking
  matches,
  sanctions,
  loadMatches,
  loadSanctions,
  createDebt,
  loadPlayerFinancials,
  registerPlayerInvoicesPayment,
  registerPlayerAddBalance,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [lineupIdValue, setLineupIdValue] = useState("");
  const [showLineupModal, setShowLineupModal] = useState(false);
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [showCaptainModal, setShowCaptainModal] = useState(false);
  const [selectedLineup, setSelectedLineup] = useState(null);
  const [loadingUploadFile, setLoadingUploadFile] = useState(false);
  const [showBonusModal, setShowBonusModal] = useState(false);
  const [showFinancialModal, setShowFinancialModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const getFilteredLineups = () =>
    lineups.filter((lineup) => {
      const foundId =
        lineup.id.trim().toLowerCase().indexOf(searchValue.toLowerCase()) !==
        -1;
      const foundTeamName =
        lineup.team.name
          .trim()
          .toLowerCase()
          .indexOf(searchValue.toLowerCase()) !== -1;
      return foundId || foundTeamName;
    });

  const addActions = (lineups) =>
    lineups.map((lineup) => {
      return {
        ...lineup,
        actions: (
          <div className="btn-separated-group">
            <Button
              className="btn btn-primary"
              title={<b>B</b>}
              withTooltip={true}
              tooltipTitle="Bonus"
              onClick={() => {
                setShowBonusModal(true);
                setSelectedLineup(lineup);
              }}
              loading={loadingDeleteLineup}
            />
            <Button
              className="btn btn-success"
              title={<b>C</b>}
              withTooltip={true}
              tooltipTitle="Capitán"
              onClick={() => {
                setShowCaptainModal(true);
                setSelectedLineup(lineup);
              }}
              loading={loadingDeleteLineup}
            />
            <Button
              className="btn btn-warning"
              title={<i className="fa fa-male"></i>}
              withTooltip={true}
              tooltipTitle="Jugadores"
              onClick={() => {
                openLineupPlayersModal(lineup.id), setLineupIdValue(lineup.id);
              }}
            />
            {!revaConnectionError && (
              <Button
                className="btn btn-info"
                title={<i className="fa fa-bank"></i>}
                withTooltip={true}
                tooltipTitle="Finanzas"
                onClick={() => {
                  const resolvedTournamentId = tournamentId || lineup.tournament_id || lineup.tournament?.id;
                  setSelectedAccount({
                    ...lineup,
                    name: lineup.team?.name,
                    tournament_id: resolvedTournamentId
                  });
                  loadLineupFinancials(lineup.id);
                  if (resolvedTournamentId && !priceLists[resolvedTournamentId]) loadPriceList(resolvedTournamentId);
                  setShowFinancialModal(true);
                }}
              />
            )}
            {showDeleteButton && (
              <Button
                className="btn btn-danger"
                title={<i className="fa fa-trash"></i>}
                withTooltip={true}
                tooltipTitle="Eliminar"
                onClick={() => deleteLineup(lineup.id)}
                loading={loadingDeleteLineup}
                withConfirmation={true}
                confirmationTitle="Eliminar lineup"
                onConfirmText="Confirmar"
                onCancelText="Cancelar"
                onCancelClass="btn-danger pull-left"
                confirmationBody="¿Estás seguro que quieres eliminar este lineup?"
              />
            )}
          </div>
        ),
      };
    });

  const handleShowPlayerFinancialModal = (player) => {
    const resolvedTournamentId = tournamentId || selectedLineup?.tournament_id || selectedLineup?.tournament?.id;
    setSelectedAccount({
      ...player,
      type: 'player',
      lineup_id: lineupIdValue,
      name: `${player.firstName} ${player.lastName}`,
      tournament_id: resolvedTournamentId
    });

    loadPlayerFinancials(lineupIdValue, player.id);
    if (resolvedTournamentId && !priceLists[resolvedTournamentId]) loadPriceList(resolvedTournamentId);
    setShowFinancialModal(true);
  };

  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        LineUps
        <div className="btn-group-separated pull-right">
          {roles.ROLE_MASSIVE_OPERATIONS() && (
            <UploadFileButton
              text="CSV"
              icon={<i className={`fa fa-file-text `}></i>}
              tooltipText="Alta masiva de lineups y jugadores"
              handler={async (file) => {
                setLoadingUploadFile(true);
                await uploadMasiveLinupPlayersHandler(file);
                await refreshLineups();
                setLoadingUploadFile(false);
              }}
            />
          )}
          <Button
            title={
              <span>
                <i className={`fa fa-download`}></i> Descargar
              </span>
            }
            className="btn btn-info btn-xs"
            onClick={() => downloadLineupsAndPlayersHandler()}
            withTooltip={true}
            tooltipTitle="Descargar CSV de lineups y jugadores"
          />
          <Button
            title={
              <span>
                <i className={`fa fa-wrench`}></i> Config
              </span>
            }
            className="btn btn-success btn-xs"
            onClick={() => setShowConfigModal(true)}
            withTooltip={true}
            tooltipTitle="Configuración de lineups"
          />
          <Button
            title={
              <span>
                <i className={`fa fa-plus`}></i> Lineup
              </span>
            }
            className="btn btn-primary btn-xs"
            onClick={() => setShowLineupModal(true)}
            withTooltip={true}
            tooltipTitle="Nuevo lineup"
          />
        </div>
      </div>
      <div className="panel-body">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar lineups..."
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <Table
          loading={loadingFetchLineups || loadingUploadFile}
          headers={[
            {
              label: "Nombre",
              ref: "team.name",
              className: "col-sm-8",
            },
            {
              label: "Acciones",
              ref: "actions",
              className: "col-sm-4 text-center",
            },
          ]}
          rows={loadingUploadFile ? [] : addActions(getFilteredLineups())}
          notFoundMessage="No se encontraron lineups..."
        />
      </div>
      <LineUpModal
        show={showLineupModal}
        handleShow={setShowLineupModal}
        teams={teams}
        createNewLineup={createNewLineup}
      />
      <LineUpConfigModal
        show={showConfigModal}
        handleShow={setShowConfigModal}
        updateTournament={updateTournament}
      />
      <LineUpCaptainModal
        show={showCaptainModal}
        handleShow={setShowCaptainModal}
        lineup={selectedLineup}
        addLineupCaptain={addLineupCaptain}
      />
      <LineUpBonusModal
        show={showBonusModal}
        handleShow={setShowBonusModal}
        lineup={selectedLineup}
        addLineupBonus={addLineupBonus}
      />

      <PlayersModal
        show={showPlayersModal}
        handleShow={hidePlayersModal}
        teams={teams}
        player={player}
        players={players}
        clearSinglePlayer={clearSinglePlayer}
        setPlayerKeyValue={setPlayerKeyValue}
        addPlayerToLineup={addPlayerToLineup}
        setSinglePlayer={setSinglePlayer}
        loadingAddPlayerToLineup={loadingAddPlayerToLineup}
        updatePlayer={updatePlayer}
        clearAllPlayers={clearAllPlayers}
        loadingFetchPlayers={loadingFetchPlayers}
        loadingUpdatePlayer={loadingUpdatePlayer}
        loadingDeletePlayer={loadingDeletePlayer}
        deletePlayerHandler={deletePlayerHandler}
        deletePlayerImageHandler={deletePlayerImageHandler}
        floatingAlert={floatingAlert}
        lineupIdValue={lineupIdValue}
        handleShowFinancialModal={handleShowPlayerFinancialModal}
      />

      <FinancialModal
        show={showFinancialModal}
        onClose={() => setShowFinancialModal(false)}
        account={selectedAccount}
        organizerId={organizerId}
        financials={selectedLineupFinancials}
        invoices={selectedLineupInvoices}
        siloBalances={selectedLineupSiloBalances}
        priceList={priceLists[selectedAccount?.tournament_id]}
        loading={loadingReva}
        applyPriceItem={applyPriceItem}
        registerInvoicesPayment={registerInvoicesPayment}
        registerAddBalance={registerAddBalance}
        // New Props
        matches={matches}
        sanctions={sanctions}
        loadMatches={loadMatches}
        loadSanctions={loadSanctions}
        createDebt={createDebt}
      />
    </div>
  );
};

export default LineUpList;
